import * as React from 'react';
import NonTextInput from './NonTextInput';
import { HatType } from './Hat';
import Popup from './Popup';
import NewCard from './NewCard';
import formatter from '../utils/formatter-util';

export interface EditablePayMethodProps {
  name: string;
  label: string;
  id: string;
  ariaLabel?: string;
  readOnly?: boolean;
  hasError?: boolean;
  errors?: any;
  theme?: 'night' | 'day';
  hat?: HatType[];
  disabled?: boolean;
  iconPath?: string;
  value?: string;
  text?: string;
  additionalText?: string;
  onClose?: () => void;
  expMonth: string;
  expYear: string;
  cardNumber: string;
  cardBrand: string;
  addCardLinkText?: string;
  focus?: boolean;
  newCardLabel?: string;
  showPopUp?: boolean;
  onUpdateCard?: Function;
}

export interface EditablePayMethodState {
  expMonth?: string;
  expYear?: string;
  cardNumber?: string;
  cardBrand?: string;
  showPopUp: boolean;
  flipBg: string;
}

export default function EditablePayMethod(props: EditablePayMethodProps) {
  const {
    theme = 'day',
    addCardLinkText = 'Update Card',
    newCardLabel = 'Payment Method'
  } = props;

  const [state, setState] = React.useState<EditablePayMethodState>({
    expMonth: props.expMonth,
    expYear: props.expYear,
    cardBrand: props.cardBrand,
    cardNumber: props.cardNumber,
    showPopUp: false,
    flipBg: ''
  });
  const editablePayRef: any = React.useRef();

  React.useEffect(() => {
    if (props.expMonth !== state.expMonth || props.expYear !== state.expYear) {
      setState({
        ...state,
        expYear: props.expYear,
        expMonth: props.expMonth
      });
    }
  }, [props.expMonth, props.expYear]);

  const handleClickOutside = (event: any) => {
    if (state.showPopUp) {
      if (
        editablePayRef.current &&
        editablePayRef.current.contains(event.target)
      ) {
        return;
      }
      setState((prevState: EditablePayMethodState) => ({
        ...prevState,
        showPopUp: false
      }));
    }
  };
  React.useEffect(() => {
    if (props.showPopUp) {
      setState({
        ...state,
        showPopUp: !!props.showPopUp
      });
      if (props.onClose) {
        props.onClose();
      }
    }
  }, [props.showPopUp]);

  React.useEffect(() => {
    if (state.expMonth !== props.expMonth || state.expYear !== props.expYear) {
      setState({
        ...state,
        expYear: props.expYear,
        expMonth: props.expMonth
      });
    }
  }, [props.expMonth, props.expMonth]);

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  const formatCard = formatter({
    type: 'card',
    format: props.cardBrand,
    value: props.cardNumber
  });
  return (
    <>
      <div>
        <NonTextInput
          ariaLabel={props.ariaLabel}
          readOnly={props.readOnly}
          focus={props.focus}
          hasError={props.hasError}
          errors={props.errors}
          theme={props.theme}
          hat={props.hat}
          name={props.name}
          id={props.id}
          isComplete
          onClick={() => {
            setState({ ...state, showPopUp: !state.showPopUp });
          }}
          iconPath={props.iconPath}
          label={props.label}
          value={props.value}
          text={formatCard}
          additionalText={
            !!state.expMonth && !!state.expYear
              ? `${state.expMonth} / ${state.expYear.slice(
                  state.expYear.length - 2
                )}`
              : ''
          }
          disabled={props.disabled}
        >
          {!props.readOnly && <div className="dropdown__arrow"> </div>}
        </NonTextInput>
        {state.showPopUp && (
          <div>
            <Popup
              modal
              displayCloseButton
              position="relative"
              className="dropdown__list"
              onClose={props.onClose}
              theme={theme}
            >
              <div ref={editablePayRef}>
                <NewCard
                  displayDetails
                  onAddCard={cardDetails => {
                    if (props.onUpdateCard) {
                      props.onUpdateCard({
                        expYear: cardDetails.expYear,
                        expMonth: cardDetails.expMonth
                      });
                    }
                    setState({
                      ...state,
                      expYear: cardDetails.expYear,
                      expMonth: cardDetails.expMonth,
                      showPopUp: false
                    });
                  }}
                  hideSavePaymentInfo
                  hideCreditCardInput
                  hideCVVInput
                  addCardLink={addCardLinkText}
                  newCardLabel={newCardLabel}
                  cardNumber={state.cardNumber}
                  cardBrand={state.cardBrand}
                  expYear={state.expYear}
                  expMonth={state.expMonth}
                />
              </div>
            </Popup>
          </div>
        )}
      </div>
    </>
  );
}
